import { useSelector } from "react-redux";
import useAuth from "utils/hooks/useAuth";

const apiPrefix = process.env.REACT_APP_API;

const appConfig = {
  apiPrefix,
  unAuthenticatedEntryPath: "/sign-in",
  tourPath: "/",
  enableMock: false,
  apiVersion: "v1",
};

export default appConfig;
